import { render, staticRenderFns } from "./BalanceDisplayer.vue?vue&type=template&id=24fa1781&"
import script from "./BalanceDisplayer.vue?vue&type=script&lang=js&"
export * from "./BalanceDisplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports